(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ka-header"]) return;
  try {
    
document.addEventListener('click',function(event){const header=event.target.closest('.ka-header');document.querySelectorAll('.ka-header details[open]').forEach(function(item){if(!header||(!item.contains(event.target)&&event.target.closest('summary')))item.open=false;});if(event.target.closest('.ka-mobile-menu nav a'))event.target.closest('details').open=false;});
document.addEventListener('keydown',function(event){if(event.key==='Escape')document.querySelectorAll('.ka-header details[open]').forEach(function(item){item.open=false;item.querySelector('summary').focus();});});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["keiray-routine"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('keiray-routine'))customElements.define('keiray-routine',class extends HTMLElement{
connectedCallback(){this.form=this.querySelector('form');this.result=this.querySelector('.k-quiz-results');this.labels=JSON.parse(this.querySelector('[data-labels]').textContent);this.products=JSON.parse(this.querySelector('[data-products]').textContent);this.status=this.querySelector('.k-routine-status');this.add=this.querySelector('.k-routine-add');this.form.addEventListener('submit',e=>{e.preventDefault();if(this.form.reportValidity())this.build();});this.add.addEventListener('click',()=>this.addToBag());}
normal(v){return String(v||'').toLowerCase().replaceAll('_',' ').trim();}
match(arr,value){return (arr||[]).some(v=>this.normal(v)===this.normal(value));}
build(){const a=Object.fromEntries(new FormData(this.form));const L=this.labels;this.result.hidden=false;this.status.textContent='';this.querySelector('.k-result-note').textContent=a.sensitivity==='high'||a.current==='new'?L.gentle:a.current==='established'?L.established_note:L.simple;const steps=['cleanse','moisturize','protect'];if(a.concern!=='none'&&a.sensitivity!=='high'&&a.current==='established')steps.splice(1,0,'treat');const list=this.querySelector('.k-routine-steps');list.replaceChildren();for(const step of steps){const li=document.createElement('li');const h=document.createElement('h4');h.textContent=L[step];const p=document.createElement('p');p.textContent=L[step+'_note'];li.append(h,p);list.append(li);}let left=a.budget==='any'?Infinity:Number(a.budget)*100;this.matches=[];const aliases={dryness:['dryness','dehydration'],sensitivity:['sensitivity','sensitive skin'],dullness:['dullness','uneven tone'],texture:['texture','breakouts'],fine_lines:['fine lines']};for(const step of steps){let eligible=this.products.filter(p=>p.available&&p.step===step&&p.price<=left&&(a.sensitivity!=='high'||p.sensitive===true)&&(this.match(p.skin,'all skin types')||this.match(p.skin,a.skin))&&(step!=='treat'||(aliases[a.concern]||[]).some(c=>this.match(p.concerns,c))));eligible.sort((x,y)=>{const score=p=>(aliases[a.concern]||[]).some(c=>this.match(p.concerns,c))*4+(a.texture!=='any'&&this.normal(p.texture).includes(a.texture)?1:0);return score(y)-score(x)||x.price-y.price;});if(eligible[0]){this.matches.push(eligible[0]);left-=eligible[0].price;}}const grid=this.querySelector('.k-routine-products');grid.replaceChildren();for(const p of this.matches){const label=document.createElement('label');const box=document.createElement('input');box.type='checkbox';box.value=p.id;box.checked=true;box.setAttribute('aria-label',L.selection_label+' '+p.title);box.addEventListener('change',()=>this.total());const span=document.createElement('span');const link=document.createElement('a');link.href=p.url;link.textContent=p.title;span.append(link,document.createElement('br'),document.createTextNode(this.money(p.price)));label.append(box,span);grid.append(label);}this.add.hidden=!this.matches.length;this.total();if(!this.matches.length)this.status.textContent=L.catalog_pending;else if(this.matches.length<steps.length)this.status.textContent=L.partial+' '+this.status.textContent;this.result.focus({preventScroll:true});this.result.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'start'});}
money(cents){return new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:this.dataset.currency}).format(cents/100);}
selected(){const ids=Array.from(this.querySelectorAll('.k-routine-products input:checked')).map(x=>x.value);return this.matches.filter(p=>ids.includes(String(p.id)));}
total(){const selected=this.selected();this.add.disabled=!selected.length;this.status.textContent=selected.length?this.labels.selected_total+' '+this.money(selected.reduce((s,p)=>s+p.price,0)):this.labels.no_selection;}
async addToBag(){
  const selected=this.selected();
  if(this.pending||!selected.length)return;
  this.pending=true;
  this.add.disabled=true;
  this.status.textContent=this.labels.adding;
  try{
    const root=this.dataset.root;
    const drawer=document.querySelector('cart-drawer');
    const response=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:selected.map(p=>({id:p.id,quantity:1})),sections:['cart-drawer','cart-icon-bubble'],sections_url:location.pathname})});
    const data=await response.json();
    if(!response.ok||data.status)throw new Error(data.description||this.labels.failed);
    this.status.textContent=this.labels.added;
    const canRender=drawer&&['cart-drawer','cart-icon-bubble'].every(key=>typeof data.sections?.[key]==='string'&&data.sections[key].trim());
    if(canRender){
      try{
        drawer.setActiveElement(this.add);
        drawer.classList.remove('is-empty');
        drawer.renderContents(data);
      }catch{
        location.assign(root+'cart');
      }
    }else location.assign(root+'cart');
  }catch(e){
    this.status.textContent=e.message||this.labels.failed;
  }finally{
    this.pending=false;
    this.add.disabled=!this.selected().length;
  }
}
});

  } catch(e) { console.error(e); }
})();
})();
